import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
//import { ClassroomSummary } from '../../../classroom-summary/models/classroom-summary.model';
import { MassEmailStudent, MassEmail } from '../../mass-email.model';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { LoginSettings } from '../../../../shared-modules/login/LoginSetting.model';
import { ClassroomSummary } from '../../../../classroom360/classroom-summary/models/classroom-summary.model';


@Component({
  selector: 'app-by-class-row-student',
  templateUrl: './by-class-row-student.component.html'
})
export class ByClassRowStudentComponent implements OnInit {
  // ----------Angular Material------------------------------------
  massEmail: MassEmail;
  angularMatData = new TylerMatTableDataSource();
  loginSettings: LoginSettings;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  columnsToDisplayInDetailClassView = ['Select', 'StudentNumber', 'Name', 'GradeLevel', 'Email'];
  @Input() classRow: ClassroomSummary;
  selectedStudents: MassEmailStudent[] = [];


  constructor(private loginService: LoginService) { }

  ngOnInit() {
    this.loginSettings = this.loginService.LoginSettings;
    this.angularMatData.data = this.classRow.Students;
    this.selectedStudents = this.classRow.Students;
    this.angularMatData.sort = this.sort;
  }

  classStudentsCheckAllClick(course) {
    for (let i = 0; i < this.selectedStudents.length; i++) {
      if (this.loginSettings.V10) {
        this.selectedStudents[i].SelectedClasses[course.SSEC_ID] = course.classStudentsCheckAll;
      }
      else {
        this.selectedStudents[i].SelectedClasses[course.Id] = course.classStudentsCheckAll;
      }
      if (this.selectedStudents[i].SelectedClasses.find(c => c == true) == null) {
        this.selectedStudents[i].IsSelected = false;
      }
      else {
        this.selectedStudents[i].IsSelected = true;
      }
    }

  }

  classStudentClick(student: MassEmailStudent, course: ClassroomSummary) {
    course.classStudentsCheckAll = true;
    if (student.SelectedClasses.find(c => c == true) == null) {
      student.IsSelected = false;
    }
    else {
      student.IsSelected = true;
    }
    if (this.loginSettings.V10) {
      if (student.SelectedClasses[course.SSEC_ID] != true) {
        course.classStudentsCheckAll = false;
      }
      else {
        if (this.selectedStudents.find(studentObj => studentObj.SubjectSections.find(c => c == course.SSEC_ID) != null && studentObj.SelectedClasses[course.Id] != true) != null) {
          course.classStudentsCheckAll = false;
        }

      }
    }
    else {
      if (student.SelectedClasses[course.Id] != true) {
        course.classStudentsCheckAll = false;
      }
      else {
        if (this.selectedStudents.find(studentObj => studentObj.SubjectSections.find(c => c == course.Id) != null && studentObj.SelectedClasses[course.Id] != true) != null) {
          course.classStudentsCheckAll = false;
        }
      }
    }
  }

  getAriaDetailRow(row) {

  }
}
